import { render } from "./zcfzTable2.vue?vue&type=template&id=10bb61d2&scoped=true"
import script from "./zcfzTable2.vue?vue&type=script&lang=js"
export * from "./zcfzTable2.vue?vue&type=script&lang=js"

import "./zcfzTable2.vue?vue&type=style&index=0&id=10bb61d2&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10bb61d2"]])

export default __exports__